import React from 'react';
import { useGetBalance } from 'hooks/api/portfolio';
import MetricItem from 'components/MetricCard';
import messages from './IraUserBalance.messages';

const IraUserBalance: React.FC = () => {
  const { isLoading, data } = useGetBalance();

  return (
    <MetricItem label={messages.label} amount={data?.amount} isLoading={isLoading} />
  );
};

export default IraUserBalance;
